"use strict";

exports.__esModule = true;
exports["default"] = ReferenceDesign;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ReferenceDesign(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("ellipse", {
    cx: "46.74",
    cy: "464.02",
    rx: "46.74",
    ry: "47.98"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M480.84 419V301a48.14 48.14 0 0 0 0-90.09V48a15.78 15.78 0 0 0-15.58-16H299.88C293.44 13.4 276.32 0 256 0c-25.81 0-46.74 21.48-46.74 48S230.19 96 256 96c20.32 0 37.44-13.39 43.87-32h149.81v147a48.14 48.14 0 0 0 0 90.09V419a47.21 47.21 0 0 0-28.29 29H299.87c-6.44-18.59-23.55-32-43.87-32-25.81 0-46.74 21.48-46.74 48s20.93 48 46.74 48c20.32 0 37.44-13.4 43.88-32h121.51c6.44 18.6 23.56 32 43.88 32 25.81 0 46.74-21.48 46.74-48a47.77 47.77 0 0 0-31.17-45z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M365.05 335.53V175.58c0-17.59-14-32-31.16-32H178.1c-17.13 0-31.16 14.39-31.16 32v64H62.32V93a47.77 47.77 0 0 0 31.16-45c0-26.5-20.93-48-46.74-48S0 21.48 0 48a47.77 47.77 0 0 0 31.16 45v162.55a15.78 15.78 0 0 0 15.58 16h100.2v64c0 17.59 14 32 31.16 32h155.79c17.11-.03 31.16-14.43 31.16-32.02z"
  }));
}